(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baudelia-baby"] && !Shopify.designMode) return;
  try {
    
if (!window.cozimoovGalleryReady) {
window.cozimoovGalleryReady = true;
document.addEventListener('click', (event) => {
const button = event.target.closest('[data-cozi-image]');
if (!button) return;
const gallery = button.closest('.cp-gallery');
const image = gallery.querySelector('.cp-main-image img');
image.removeAttribute('srcset');
image.src = button.dataset.coziImage;
image.alt = button.dataset.coziAlt;
gallery.querySelectorAll('[data-cozi-image]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
});
}

document.addEventListener('click', (event) => {
document.querySelectorAll('.cozi-nav-mobile[open]').forEach(menu => {
if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
});
});
document.addEventListener('keydown', (event) => {
if (event.key !== 'Escape') return;
document.querySelectorAll('.cozi-nav-mobile[open]').forEach(menu => {
menu.open = false;
menu.querySelector('summary').focus();
});
});


  } catch(e) { console.error(e); }
})();
})();
